import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconGoldMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGoldMedal"><Circle cx="12" cy="10" r="8" stroke="currentColor"/><Path d="M7.5 16.5V22.5L12 21L16.5 22.5V16.5" stroke="currentColor"/><Path d="M12.5547 6V14H11.3438V7.21094H11.2969L9.38281 8.46094V7.30469L11.3789 6H12.5547Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGoldMedal;
